import React from 'react';
import { FlameIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
const features = [{
  icon: FlameIcon,
  title: 'First Responder Owned',
  description: 'We bring the same discipline and reliability from the firehouse to your backyard.'
}, {
  icon: ShieldCheckIcon,
  title: 'Licensed, Bonded & Insured',
  description: 'Your property is fully protected. We carry full coverage for every job.'
}, {
  icon: StarIcon,
  title: '5-Star Rated',
  description: 'Consistently rated 5 stars by Arizona homeowners on Google.'
}];
export function WhyChooseSection() {
  return <section className="py-16 md:py-24 px-6 bg-white" data-id="element-216">
      <div className="container mx-auto max-w-7xl" data-id="element-217">
        <div className="text-center mb-16" data-id="element-218">
          <span className="text-brand-red uppercase text-sm font-bold tracking-wider block mb-3" data-id="element-219">
            Why Redline
          </span>
          <h2 className="text-charcoal text-3xl md:text-4xl font-bold uppercase tracking-wide" data-id="element-220">
            Why Homeowners Trust Redline
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-221">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="flex flex-col items-center text-center group" data-id="element-222">
                <div className="w-20 h-20 rounded-full bg-brand-red flex items-center justify-center mb-6 text-white shadow-lg group-hover:scale-110 group-hover:bg-brand-red-dark transition-all duration-300" data-id="element-223">
                  <Icon size={40} strokeWidth={1.5} data-id="element-224" />
                </div>
                <h3 className="text-2xl font-bold text-charcoal mb-4 uppercase tracking-wide" data-id="element-225">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-226">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}